module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-sidebar', {
    attrs: {
      "activeNavItem": "contact"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": 'Contacts'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card data-tables"
  }, [_c('div', {
    staticClass: "card-body table-striped table-no-bordered table-hover dataTable dtr-inline table-full-width"
  }, [_c('div', {
    staticClass: "toolbar text-right",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-wd",
    on: {
      "click": function($event) {
        return _vm.addContact()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Add Contact")])]), _vm._v(" "), _c('span', {
    staticClass: "loading text-muted"
  }, [_vm._v("  Loading...")]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-wd",
    on: {
      "click": function($event) {
        return _vm.addContact()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Add Contact")])])])])]), _vm._v(" "), _vm._m(1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fresh-datatables",
    staticStyle: {
      "display": "none"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "datatables_contacts",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Website")]), _vm._v(" "), _c('th', [_vm._v("Company")]), _vm._v(" "), _c('th', [_vm._v("Phone Number")]), _vm._v(" "), _c('th', [_vm._v("Address")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', [_c('p', {
    staticClass: "copyright text-center"
  }, [_vm._v("\n            © 2020 Raefton\n          ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e5849b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contact/view.vue
// module id = 676
// module chunks = 0